const FP_KEY = "ww_browser_fingerprint";
const LOGIN_HINT_KEY = "ww_login_hint";

function randomHex(len: number): string {
  const bytes = new Uint8Array(len);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < len; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

export function ensureClientFingerprint(): string {
  try {
    const existing = localStorage.getItem(FP_KEY)?.trim();
    if (existing) return existing;
    const fp = `ww-${Date.now().toString(36)}-${randomHex(8)}`;
    localStorage.setItem(FP_KEY, fp);
    return fp;
  } catch {
    return `ww-ephemeral-${randomHex(8)}`;
  }
}

export function setClientLoginHint(login: string): void {
  const value = String(login || "").trim().toLowerCase().slice(0, 120);
  try {
    if (value) localStorage.setItem(LOGIN_HINT_KEY, value);
    else localStorage.removeItem(LOGIN_HINT_KEY);
  } catch {
    // ignore storage errors
  }
}

export function getClientLoginHint(): string {
  try {
    return (localStorage.getItem(LOGIN_HINT_KEY) || "").trim().slice(0, 120);
  } catch {
    return "";
  }
}
